import _ from '@/utils/lodash-optimized'
import moment from 'moment'
import { createRef, Component } from 'react'

import { withLegacyRouter } from '../../../../decorators'
import { DiagnosticCategories } from '../../../../lib/Codes'
import DownloadLink from '../../../shared/DownloadLink/DownloadLink'
import {
  bindTargetMixin,
  CancelButton,
  DateInput,
  FileInput,
  CheckboxInput,
  SaveButton,
  SelectInput,
  TextInput
} from '../../../shared/FormBuilder'
import { documentsFileTypes } from '../../../shared/FormBuilder/File'
import { Paper, RequiredSpan } from '../../../shared/NarusMaterial'

@withLegacyRouter
export default class DiagnosticsForm extends bindTargetMixin(Component) {
  constructor (props) {
    super(props)
    this.fileInputOnChange = this.fileInputOnChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.fileInputRef = createRef()
  }

  componentDidMount () {
    this.setState({
      isSubmitting: false
    })
  }

  getValue () {
    return {
      ...this.state.value,
      uploadedBy: {
        reference: `Practitioner/${this.props.currentUser.id}`,
        display: this.props.currentUser.display
      },
      uploaded: moment().format('MM/DD/YYYY HH:mm:ss')
    }
  }

  handleSubmit () {
    const { onSubmit } = this.props

    const value = this.getValue()
    const fileInput = this.fileInputRef.current

    let uploadPromise = null

    if (fileInput) {
      if (fileInput.isFileSelected()) {
        uploadPromise = fileInput.doUpload().then(uploadedFiles => {
            value.attachedFileMeta = uploadedFiles?.files?.file0
        })
      } else {
        uploadPromise = null
      }
    } else {
      uploadPromise = Promise.resolve(value.attachedFileMeta)
    }

    if (uploadPromise) {
      this.setState({
        isSubmitting: true,
        errors: null
      })

      uploadPromise
        .then(() => {
          if (onSubmit) {
            onSubmit(value)
          }
        })
        .catch(e => {
          this.setState({
            isSubmitting: false,
            errors: {
              fileInput: [ e.message ]
            }
          })
        })
    } else {
      this.setState({
        errors: {
          fileInput: [
            `Please, select a valid file (${fileInput
              .supportedFileTypes()
              .join(', ')}).`
          ]
        }
      })
    }
  }

  fileInputOnChange () {
    this.setState({
      errors: {
        fileInput: null
      }
    })

    // This `true` needed in formbuilder's onChange callbacks chain
    return true
  }

  render () {
    const { onCancel } = this.props
    const {
      value: { file, attachedFileMeta, performer, type, mPower }
    } = this.state
    let fileFieldOrDownloadLink = null
    let disableForMpower = false

    if (file) {
      disableForMpower = file.size > 10485760 || documentsFileTypes[file.type]
      _.set(this.state, 'value.mPower', disableForMpower || mPower)
    }

    const isFileSet = file || attachedFileMeta
    const isFormEnabled = isFileSet && performer && type

    if (this.props.value.id) {
      const meta = this.state.value.attachedFileMeta

      fileFieldOrDownloadLink = (
        <DownloadLink
          meta={meta}
          patientId={this.props.params.id}
          type='DiagnosticReport'
          clientName={this.props.params.clientName}
        />
      )
    } else {
      fileFieldOrDownloadLink = (
        <FileInput
          fileRef={this.fileInputRef}
          name='file'
          label='File to upload'
          onChange={this.fileInputOnChange}
          errors={file && this.state?.errors?.fileInput}
          fileTypes='docs'
          maxSize={104857600}
        />
      )
    }

    return (
      <button
        style={{ all: 'unset', cursor: 'pointer' }}
        onKeyDown={this.props.onKeyDown}
        className='margin-top margin-bottom'
      >
        <Paper>
          <div className='row'>
            <div className='col-xs-12 col-sm-6'>
              {fileFieldOrDownloadLink}
              <div style={{ marginTop: '0.5em' }}>
                {isFileSet ? null : <RequiredSpan text='Field' />}
              </div>
            </div>

            <div className='col-xs-12 col-sm-6 mui-date-picker-extended'>
              <DateInput
                label='Performed or Collected Date'
                name='performed'
                maxLength={128}
              />
            </div>

            <div className='col-xs-12 col-sm-6'>
              <SelectInput
                options={DiagnosticCategories}
                label='Category'
                name='category'
              />
            </div>

            <div className='col-xs-12 col-sm-6'>
              <TextInput
                label='Source'
                name='source'
              />
            </div>

            <div className='col-xs-12 col-sm-6'>
              <TextInput
                label='Type'
                name='type'
                required
              />
            </div>

            <div className='col-xs-12 col-sm-6'>
              <TextInput
                label='Performer'
                name='performer'
                required
              />
            </div>

            <div className='col-xs-12 col-sm-6'>
              <CheckboxInput
                label='Not accessible from mPower'
                name='mPower'
                disabled={disableForMpower}
              />
            </div>
          </div>

          <div
            className='row end-xs'
            style={{ marginTop: '20px' }}
          >
            <div className='col-xs-12'>
              <CancelButton
                noGlobal
                onClick={onCancel}
              />
              <SaveButton
                disabled={!isFormEnabled || this.state.isSubmitting}
                onClick={this.handleSubmit}
              />
            </div>
          </div>
        </Paper>
      </button>
    )
  }
}
